import * as R from 'ramda';

export const initActionMenuState = forms => {
    return R.pipe(
        R.map(form => R.toPairs({ [form.urlFormId]: null})[0]),
        R.fromPairs
    )(forms);
};
